import React, { useMemo } from 'react';
import { Tabs, Tab } from '../../components/Tabs';
import Page from '../../components/_layout/Page';
import Newsbreak from './Newsbreak';
import NewsList from './NewsList';
import MilestonesTable from '../../components/project/Widgets/Milestones/MilestonesTable';
import useUserContext from '../../hooks/useUserContext';
import { isAdmin } from '../../services/rolesSvc';

export default function News(){
	const userCtx = useUserContext()

    const tabs = useMemo(
			() => [
				{
					label: 'news',
					tabName: 'Новости',
					content: <NewsList/>,
				},
				{
					label: 'newsbreak',
					tabName: 'Инфоповоды',
					content: <MilestonesTable/>,
					hide: !isAdmin(userCtx)
				},
			],
			[userCtx]
		)

    return (
			<Page>
				<Tabs>
					{tabs
						.filter(tab => !tab.hide)
						.map((tab, i) => (
							<Tab key={i} label={tab.label} tabName={tab.tabName}>
								{tab.content}
							</Tab>
						))}
				</Tabs>
			</Page>
		)
}
